import React from 'react';
import '../Services/Lefkansi.css'; // Make sure to import your styles
import TeethMitrikos from "../Pages/images/services_images/mitrikosthilasmos.png"; // Import the image
import Services from "../Pages/Services";


import Contact from "../Pages/Contact";


const TeethMitrikosThilasmosComponent = () => {
  return (
    <div className="teeth-whitening-container">
      <h2>ΜΗΤΡΙΚΟΣ ΘΗΛΑΣΜΟΣ ΚΑΙ Η ΕΠΙΡΡΟΗ ΤΟΥ ΣΤΑ ΝΕΟΓΙΛΑ ΔΟΝΤΙΑ</h2>
      {/* Main Image */}
      <img src={TeethMitrikos } alt="Teeth Ritini"  className="specific-image" />
      <p>
    
Η πράξη του θηλασμού με τα νεογιλά δόντια, δεν επηρεάζει τα δόντια. Το γάλα που παραμένει στο στοματάκι και επικάθεται στα πρώτα δόντια, όσα από αυτά έχουν ανατείλει, συνεχώς και ιδιαίτερα όλη την νύχτα, δημιουργεί πρόβλημα.
Παρατηρείται τερηδόνα, η οποία ξεκινάει με ‘λευκωπά σημάδια’ στο επάνω τριτημόριο των μπροστινών συνήθως νεογιλών δοντιών, σύρριζα με τα ούλα του παιδιού. Αν αυτά δεν αντιμετωπιστούν, τα ‘λευκωπά’ σημάδια γίνονται κίτρινα- καφέ και μετά οι γονείς βλέπουν τρύπες είτε στο επάνω μέρος των δοντιών είτε στις ενδιάμεσες επιφάνειές τους. Παρά την άποψη ότι ‘τα παιδικά δόντια’ ‘αλλάζουν’, άρα δεν μας νοιάζει πολύ, το παιδί τα χρειάζεται για τουλάχιστον 5-12 χρόνια. Με αυτά τα δόντια το παιδί ξεκινάει να τρώει, μαθαίνει να μιλάει και να ωριμάζει αισθητηριακά. Στον χώρο που καταλαμβάνουν τώρα τα νεογιλά δόντια, θα έρθουν αργότερα τα μόνιμα, άρα διατηρούν αυτό τον χώρο για την ομαλή διαδοχή των δοντιών. Και βέβαια, κανείς δεν θέλει ‘μαύρα’ παιδικά χαμόγελα, ή νήπια με πόνο και αποστήματα, όπως στην περίπτωση του ‘συνδρόμου του μπιμπερό’ όπου τα παιδικά δόντια καταστρέφονται από το γάλα που πίνουν τα νήπια καθ’όλη την διάρκεια της νύχτας κοιμώμενα με το μπουκάλι στο στόμα. Γι αυτό το λόγο οι γονείς πρέπει πλέον ενημερώνονται και ευαισθητοποιούνται από τους παιδίατρους, και τους παιδοδοντιατρους, όσον αφορά την κατάχρηση του μπιμπερό. Άρα, ‘παν μέτρον άριστον’. Ναι, στον μητρικό θηλασμό, αλλά όχι στον παρατεταμένο. Συστήνεται καθημερινός καθαρισμός των νεογιλών δοντιών, μόλις αυτά ανατείλουν, με μια βρεγμένη γάζα ή βρεφική οδοντόβουρτσα. 

      </p>
      
    
     
      <Services/>
      <Contact />
    </div>
  );
};

export default TeethMitrikosThilasmosComponent;
